import useAsyncData from 'src/utils/useAsyncData';
import { getBanksAPI } from 'src/serverApi/banks';
import permissions from 'src/constants/permissions';

const useBanks = () => {
  const [fetchBanks, wasBanksFetched, isBanksLoading, banks, banksError] = useAsyncData(
    getBanksAPI,
    [permissions.dataManagement]
  );

  return {
    fetchBanks,
    wasBanksFetched,
    isBanksLoading,
    banks,
    banksError,
  };
};

export default useBanks;
